module.exports = __webpack_public_path__ + "pw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pw.svg
// module id = 771
// module chunks = 0